<h2
    class="text-gray-700 font-bold text-lg lg:text-2xl dark:text-white"
    [style.--custom-title-color]="color || null"
>
    <div class="flex items-center gap-2">
        <span
            class="inline-flex p-2 rounded-xl shadow-md"
            [class]="color ? '' : defaultColor"
            [style.background-color]="color || ''"
        >
            <mat-icon class="text-white" [svgIcon]="icon"></mat-icon>
        </span>
        <span>{{ title }}</span>
    </div>
</h2>
